import { Injectable, Renderer2 } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidationMessageService } from './validation-message.service';

@Injectable({ providedIn: 'root' })
export class DomValidationService {

	constructor(private msgService: ValidationMessageService) { }

	render(
		el: HTMLElement,
		renderer: Renderer2,
		control: AbstractControl,
		cGrupo: string,
		cCampo: string
	) {
		const groupContainer = el.querySelector(
			`[formGroupName="${cGrupo}"]`
		);
		if (!groupContainer) return;

		const input = groupContainer.querySelector(
			`[formControlName="${cCampo}"]`
		);
		if (!input) return;

		const parent = input.parentElement;

		// limpiar errores previos
		const existingErrors = parent.querySelectorAll('.dynamic-error');
		existingErrors.forEach(err => renderer.removeChild(parent, err));

		const message = this.msgService.build(control, cCampo);
		if (!message) return;

		const small = renderer.createElement('small');
		renderer.addClass(small, 'dynamic-error');
		renderer.setStyle(small, 'color', '#dc3545');
		renderer.setStyle(small, 'fontSize', '0.8rem');
		small.innerHTML = message;

		renderer.appendChild(parent, small);
	}
}